import React from 'react';
import Grid from '@material-ui/core/Grid';
import homePageStyles from '../home.module.css';
import sectionStyles from './index.module.css';
import { AboutIllustration } from '../HomeDecor';

class AboutSection extends React.Component {
  render() {
    return (
      <section className={`${homePageStyles.aboutSection} section`}>
        <Grid container spacing={0} className={`${sectionStyles.contentContainer} contentContainer`}>
          <Grid item xs={12} lg={7}>
            <div className={`${sectionStyles.aboutUsArticleContainer}`}>
              <div className={`sectionTitle`}>About Us</div>
              <div className={`sectionTitleUnderline`} />
              <div className={sectionStyles.foundedMeta}>
                Founded in 2017 · Based in Canada
              </div>
              <div className={`articleBigTitle`}>
                Stable, long-term partnerships
              </div>
              <p className={`generalArticle`}>
                Mimosa Solutions has been in operation since 2017. We focus on reliable delivery and steady improvement so owners and teams can depend on our software year after year—not just at launch.
              </p>
              <p className={`generalArticle ${sectionStyles.secondParagraph}`}>
                We are a Canadian software company that turns operational challenges into practical products. Our team works closely with clients to ship industry-leading membership and billing tools, improve productivity, and support better customer service.
              </p>
            </div>
          </Grid>
          <Grid item xs={12} lg={5}>
            <AboutIllustration />
          </Grid>
        </Grid>
      </section>
    );
  }
}

export default AboutSection;